// @flow
import React from 'react';
import { range } from '../../../../helpers';
import { NavigationContainer, SliderNavigation } from './atoms';

type Props = {
  slideCount: number,
  selectedSlide: number,
  onChangeSlide: (index: number) => void,
};

const Navigation = ({
  slideCount,
  selectedSlide,
  onChangeSlide,
}: Props) => (
  <NavigationContainer>
    {range(0, slideCount).map(index => (
      <SliderNavigation
        key={index}
        onClick={() => onChangeSlide(index)}
        selected={selectedSlide !== index}
      />
    ))}
  </NavigationContainer>
);

export default Navigation;
